import styled from 'styled-components/macro'
import { rem, media } from '../../utils/styles'

const Stepper = styled.ol`
  display: flex;
  flex-direction: column;
  margin: ${rem(32)} 0;
  padding: 0;
  counter-reset: stepper;
  list-style: none;

  ${media('tablet')`flex-direction: row;`}
`

export default Stepper
